//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const pedidoDevolucaoService = {
  doGet,
  doSave,
  findByFiltro,
  doDelete,
  marcarColetado,
  cancelarColeta,
  voltarColetaPendente,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  console.log(filter);

  const params = [];

  if (_.get(filter, 'cliente.codigoCliente')) {
    params.push(
      `codigoCliente=${encodeURIComponent(filter.cliente.codigoCliente)}`,
    );
  }

  if (_.get(filter, 'pontoAtendimentoId')) {
    params.push(
      `pontoAtendimentoId=${encodeURIComponent(filter.pontoAtendimentoId)}`,
    );
  }

  if (_.get(filter, 'status')) {
    params.push(`status=${encodeURIComponent(filter.status)}`);
  }

  if (_.get(filter, 'statusColeta')) {
    params.push(`statusColeta=${encodeURIComponent(filter.statusColeta)}`);
  }

  if (_.get(filter, 'criadoPor') !== undefined && filter.criadoPor !== null) {
    params.push(`criadoPor=${encodeURIComponent(filter.criadoPor)}`);
  }

  if (
    _.get(filter, 'aprovadoPor') !== undefined &&
    filter.aprovadoPor !== null
  ) {
    params.push(`aprovadoPor=${encodeURIComponent(filter.aprovadoPor)}`);
  }

  if (_.get(filter, 'numeroPedido')) {
    params.push(`numeroPedido=${encodeURIComponent(filter.numeroPedido)}`);
  }

  if (filter.urgente != null) {
    params.push(`urgente=${encodeURIComponent(filter.urgente)}`);
  }

  if (filter.createdAt != null) {
    let iso;

    if (filter.createdAt instanceof Date) {
      iso = filter.createdAt.toISOString();
    } else if (typeof filter.createdAt === 'string') {
      iso = new Date(filter.createdAt).toISOString();
    }

    if (iso) {
      params.push(`createdAt=${encodeURIComponent(iso)}`);
    }
  }

  if (filter.dataColeta != null) {
    let iso;

    if (filter.dataColeta instanceof Date) {
      iso = filter.dataColeta.toISOString();
    } else if (typeof filter.dataColeta === 'string') {
      iso = new Date(filter.dataColeta).toISOString();
    }

    if (iso) {
      params.push(`dataColeta=${encodeURIComponent(iso)}`);
    }
  }

  if (
    _.get(filter, 'responsavel') !== undefined &&
    filter.responsavel !== null
  ) {
    params.push(`responsavel=${encodeURIComponent(filter.responsavel)}`);
  }

  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }

  const queryString = params.length ? `?${params.join('&')}` : '';

  return defaultService.doGet(
    `${urlsConstants.API_PEDIDO_DEVOLUCAO}filtro${queryString}`,
    options,
  );
}

function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.API_PEDIDO_DEVOLUCAO}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_PEDIDO_DEVOLUCAO}${id}`);
}

function doSave(pd) {
  return defaultService.doSave(urlsConstants.API_PEDIDO_DEVOLUCAO, pd);
}

function marcarColetado(id, observacao) {
  return defaultService.doPut(
    `${urlsConstants.API_PEDIDO_DEVOLUCAO}${id}/coleta/coletado`,
    {
      observacao,
    },
  );
}

function cancelarColeta(id, observacao) {
  return defaultService.doPut(
    `${urlsConstants.API_PEDIDO_DEVOLUCAO}${id}/coleta/cancelado`,
    {
      observacao,
    },
  );
}

function voltarColetaPendente(id, observacao) {
  return defaultService.doPut(
    `${urlsConstants.API_PEDIDO_DEVOLUCAO}${id}/coleta/pendente`,
    {
      observacao,
    },
  );
}
